// extracted by mini-css-extract-plugin
module.exports = {"status":"status-1qvNL","waiting":"waiting-2QRli","rejected":"rejected-3i0ZG","processing":"processing-10IQr","icon":"icon-1DGr4"};